module.exports = __webpack_public_path__ + "static/media/1.a0d6cf39.png";